import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function maxTotalCardRangeValidator(maxSize: number): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const ranges = (group.get('ranges')?.value as { fromCardNumber: number; toCardNumber: number }[]) ?? [];
    const total = ranges.reduce((sum, r) => {
      if (r.fromCardNumber == null || r.toCardNumber == null || r.toCardNumber < r.fromCardNumber)
      {
        return sum;
      }

      return sum + (r.toCardNumber - r.fromCardNumber + 1);
    }, 0);

    return total > maxSize ? { maxRangeExceeded: total } : null;
  };
}
